import PartnerSignUpForm from "./PartnerSignUpForm";

export default PartnerSignUpForm;
